import React from "react";
import { Input } from "../../Helpers/Input/Input";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import trans from "../../../utils";
import { useFormikContext } from "formik";
import { useGetAllRolesQuery } from "../../../Redux/service/Roles&Permissions/RolesPermissions";

const TeamMemberFormBody = ({ isEditing }) => {
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
  } = useFormikContext();

  const { data: roles, isFetching } = useGetAllRolesQuery({
    page: 1,
    limit: 1000,
  });

  const roleOptions = roles?.data?.map((role) => ({
    label: role.name,
    value: role.id,
  }));
  // const roleOptions = [
  //   { label: trans("Standard User"), value: "STANDARD_USER" },
  //   { label: trans("Supervisor"), value: "SUPERVISOR" },
  //   { label: trans("Project Manager"), value: "PROJECT_MANAGER" },
  //   { label: trans("System Administrator"), value: "SYSTEM_ADMINISTRATOR" },
  // ];

  return (
    <div className="form-section">
      <div className="row">
        <div className="col-lg-12">
          <Input
            title={trans("Name")}
            type="text"
            placeholder={trans("Enter name")}
            formstyle="form-input"
            id="name"
            name="name"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.name}
            touched={touched.name}
          />
        </div>
        <div className="col-lg-12">
          <Input
            title={trans("Email")}
            type="email"
            placeholder={trans("Enter email")}
            formstyle="form-input"
            id="email"
            name="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.email}
            touched={touched.email}
            disabled={isEditing}
          />
        </div>
        <div className="col-lg-12">
          <Input
            title={trans("Phone Number")}
            type="text"
            placeholder={trans("Enter phone number")}
            formstyle="form-input"
            id="phone"
            name="phone"
            value={values.phone}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.phone}
            touched={touched.phone}
          />
        </div>
        <div className="col-lg-12">
          <InputSelect
            id="systemRole"
            name="systemRole"
            label={trans("System Role")}
            placeholder={trans("Select Role")}
            options={roleOptions}
            value={values.systemRole}
            loading={isFetching}
            disabled={isFetching}
            onChange={(val) => {
              setFieldValue("systemRole", val);
            }}
            onBlur={() => setFieldTouched("systemRole", true)}
            errors={errors.systemRole}
            touched={touched.systemRole}
            formstyle="form-input select-z-index"
          />
        </div>
      </div>
    </div>
  );
};

export default TeamMemberFormBody;
